import { useState } from "react";
import type { HandleApiCall } from "../../../../types";

export const useBraillerRepairDetails = (_handleApiCall: HandleApiCall) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [braillerLoanId, setBraillerLoanId] = useState<string | null>(null);
    const [braillerRepairId, setBraillerRepairId] = useState<string | null>(null);

    const showRepairDetails = (loanId: string, repairId: string | null = null) => {
        setBraillerLoanId(loanId);
        setBraillerRepairId(repairId);
        setIsModalOpen(true);
    };

    const closeRepairDetails = () => {
        setIsModalOpen(false);
        setBraillerLoanId(null);
        setBraillerRepairId(null);
    };

    return {
        isModalOpen,
        braillerLoanId,
        braillerRepairId,
        showRepairDetails,
        closeRepairDetails,
    };
};
